{
  "longPressMessage": "Appuyer longuement pour ouvrir la prévisualisation"
}
